import { IBaseEnumModel } from '../models';
import { DateFilterType } from '../types';

export const DateFilterOptionsConst: IBaseEnumModel[] = [
  {
    key: 'Day',
    value: DateFilterType.Day,
    localizationCode: 'За день',
  },
  {
    key: 'Week',
    value: DateFilterType.Week,
    localizationCode: 'За неделю',
  },
  {
    key: 'Month',
    value: DateFilterType.Month,
    localizationCode: 'За месяц',
  },
  {
    key: 'Year',
    value: DateFilterType.Year,
    localizationCode: 'За год',
  },
];
